import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import { QuoteCompaisonGroupDatabase } from '../../../../types';
import { usePostQuoteGroup } from '../../api/usePostQuoteGroup';

const formSchema = z.object({
  name: z.string().trim().min(1, 'Donnez un nom à la comparaison'),
});

type FormValues = z.infer<typeof formSchema>;

type Props = {
  onClose: () => void;
  afterSuccess?: (group: QuoteCompaisonGroupDatabase) => void;
};

export function useQuoteGroupFormDialog(props: Props) {
  const { mutateAsync, isPending } = usePostQuoteGroup();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { name: '' },
  });

  async function handleSubmit(values: FormValues) {
    setServerError(null);

    try {
      const group = await mutateAsync(values.name);
      props.onClose();
      props.afterSuccess?.(group);
    } catch (error: unknown) {
      setServerError(
        isSupabaseError(error) || error instanceof Error
          ? error.message
          : 'La comparaison n\'a pas pu être créée. Réessayez.',
      );
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    form,
    onSubmit: form.handleSubmit(handleSubmit),
    isPending,
    serverError,
    handleClose,
  };
}
